import { render } from "./AppHeader.vue?vue&type=template&id=724bff06"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jissjohnson/code/Bitwissend/gnaw-now-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__